import styled from 'styled-components';

export const DeliveryRow = styled.div`
  display: flex;
  padding-bottom: 36px;
`;

export const DeliveryItem = styled.div`
  flex-grow: 1;
`;

export const Label = styled.div`
  color: ${props => props.theme.color.base3};
  font-size: 12px;
  padding-bottom: 6px;
`;

export const Value = styled.div`
  font-size: 14px;
`;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/components/summary/Styled.js